import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchase-quotation-form',
  templateUrl: './purchase-quotation-form.component.html',
  styleUrls: ['./purchase-quotation-form.component.css']
})
export class PurchaseQuotationFormComponent implements OnInit {
  title="Purchase Quotation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component.ts